import login from './login';

export default {
  language: 'es-ES',
  country: 'es',
  name: 'Español',
  embeddedLocale: login,
};
